const brServiceProviders = {
  serviceProviders: {
    title: 'Prestadores de serviço',
    single: 'Prestador de serviço',
    action: {
      create: 'Criar prestador',
      createVendors: 'Criar Fornecedor (Terceiro)',
      edit: 'Atualizar prestador',
      delete: 'Remover prestador',
      save: 'Salvar prestador',
      cancel: 'Cancelar',
      link: 'Associar cliente',
      unlink: 'Remover associação de cliente',
    },
    noData: 'Sem resultados. Busque pelo nome ou documento do prestador',
    success: {
      create: 'Prestador criado com sucesso',
      update: 'Prestador atualizado com sucesso',
      delete: 'Prestador removido com sucesso',
      linked: 'Prestador vinculado com sucesso',
      unlinked: 'Prestador desvinculado com sucesso',
    },
  },
}

export default brServiceProviders
